module.exports = __webpack_public_path__ + "static/gallery-3-b8bd6535dacfed697c2acb8640b7aef5.jpg";